import {
  Component,
  ElementRef,
  inject,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  ButtonSizes,
  MotifButtonModule,
  MotifIconModule,
  MotifModalModule,
  MotifModalRef,
  MotifTooltipModule,
} from '@ey-xd/ng-motif';
import { IconoirXmark, IconoirPrivacyPolicy } from '@ey-xd/motif-icon';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { CommonService } from '@services/common.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-ipor-privacy-policy',
  imports: [
    MotifModalModule,
    MotifIconModule,
    MotifButtonModule,
    TranslatePipe,
    TranslateDirective,
    CommonModule,
    MotifTooltipModule,
  ],
  templateUrl: './ipor-privacy-policy.component.html',
  styleUrl: './ipor-privacy-policy.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class IporPrivacyPolicyComponent {
  private readonly commonService = inject(CommonService);
  private readonly route = inject(Router);
  private readonly dialogRef = inject(
    MotifModalRef<IporPrivacyPolicyComponent>,
  );
  @ViewChild('listItem') listItem!: ElementRef;
  ButtonSizes = ButtonSizes;
  IconoirXmark = IconoirXmark;
  privacyPolicyIcon = IconoirPrivacyPolicy;
  isVisible: any;
  acceptDisabled: any = true;
  constructor() {
    this.isVisible = localStorage.getItem('privacyNotice');
    if (this.isVisible === 'false') {
      this.isVisible = false;
    }
    if (this.isVisible === 'true') {
      this.isVisible = true;
    }
  }
  ngAfterViewInit(): void {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.acceptDisabled = false;
            observer.disconnect(); // Stop observing after the alert
          }
        });
      },
      { threshold: 1.0 }, // Fully visible
    );

    observer.observe(this.listItem.nativeElement);
  }

  onDecline() {
    // this.commonService.isLoading.next(true);
    this.commonService.stopWatching();
    this.commonService.clearStorage();
    this.route.navigateByUrl('/logout');
    // this.commonService.isLoading.next(false);
    localStorage.setItem('privacyNotice', 'false');
    this.dialogRef.close({ response: false });
  }
  onAccept() {
    localStorage.setItem('privacyNotice', 'false');
    this.dialogRef.close({ response: true });
  }

  ngOnDestroy(): void {
    localStorage.setItem('privacyNotice', 'false');
  }
}
